import { EntityRepository } from 'root/lsCloud/EntityRepository/EntityRepository';

export class ShopRepository extends EntityRepository {
  constructor() {
    super('Shop');
  }

  get(): JQuery.Deferred<Record<string, any>[]> {
    const deferred = $.Deferred();
    this.getAll()
      .then((shops) => deferred.resolve(shops))
      .catch(() => deferred.reject());
    return deferred;
  }
}
